export function show() {
    if (document.getElementById("progress-backdrop")) {
        return;
    }

    // Overlay
    const oBackdrop = document.createElement("div");
    oBackdrop.setAttribute("class", "fade in");
    oBackdrop.setAttribute("id", "progress-backdrop");

    // Spinner
    const oSpinner = document.createElement("div");
    oSpinner.setAttribute("id", "progress");
    oSpinner.innerHTML =
        '<i class="eva eva-loader-outline" aria-hidden="true"></i>';

    // Inject backdrop and spinner
    const oBody = document.getElementsByTagName("body")[0];

    oBody.appendChild(oBackdrop);
    oBody.appendChild(oSpinner);
}

export function hide() {
    document.getElementById("progress-backdrop")?.remove();
    document.getElementById("progress")?.remove(); 
}